import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

interface GDPRPopupProps {
  isOpen: boolean;
  onAccept: () => void;
}

export default function GDPRPopup({ isOpen, onAccept }: GDPRPopupProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black/50"
        >
          <motion.div
            initial={{ y: 50 }}
            animate={{ y: 0 }}
            exit={{ y: 50 }}
            className="bg-white rounded-xl shadow-2xl p-4 sm:p-6 max-w-2xl w-full relative overflow-hidden"
          >
            <div className="max-h-[80vh] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 pr-1">
              <div className="flex items-center justify-between gap-2 sm:gap-3 mb-3 sm:mb-4 flex-col">
                <div className="w-full">
                  <img 
                    src="https://i.imgur.com/tbt7SpM.png"
                    alt="Logotipos institucionais"
                    className="w-full object-contain"
                  />
                </div>
                <div className="flex items-center gap-2 sm:gap-3 w-full">
                  <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Workshop – Mapa participativo</h2>
                </div>
              </div>

              <div className="prose prose-blue max-w-none">
                <p className="text-gray-600 mb-3 sm:mb-4 font-bold text-sm sm:text-base">
                Obrigado desde já pelo seu interesse e disponibilidade em participar neste Workshop!
                </p>

                <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">Consentimento Informado:</h3>
                <div className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
                  <p>"Li o documento dos termos previamente disponibilizado e estou consciente do que esperar quanto à minha participação workshop - mapa participativo. Tive a oportunidade de colocar todas as questões e as respostas esclareceram todas as minhas dúvidas. Desta forma, aceito de livre vontade a participação neste estudo e permito a utilização dos dados que de forma voluntária forneço, confiando em que apenas serão utilizados para esta investigação, aceitando também a divulgação dos resultados obtidos no meio científico" </p>
                </div>

                <p className="text-gray-800 font-bold text-center mt-3 sm:mt-4 mb-3 sm:mb-4 text-sm sm:text-base">
                  NOTA: num telemóvel rode para o modo horizontal.
                </p>
              </div>

              <div className="flex justify-center mt-2 sm:mt-4">
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={onAccept}
                  className="w-full sm:w-1/2 bg-blue-500 text-white py-2 sm:py-3 px-4 rounded-lg hover:bg-blue-600 transition-colors text-sm sm:text-base"
                >
                  ACEITO E CONTINUAR
                </motion.button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}